// Centralized blog image imports so Gatsby/Webpack can resolve them.
// String paths like "/images/blog/..." don't work because those files live in src/assets, not static/.

import gettingStartedImage from "../assets/images/blog/getting-started-with-ecommerce-feeds.jpg"
import optimizeMetaCatalogImage from "../assets/images/blog/optimize-your-meta-product-catalog.jpg"
import googleProductTitleImage from "../assets/images/blog/google-product-title-optimization.jpg"
import googleProductCategoriesImage from "../assets/images/blog/google-product-categories-explained.jpg"
import shopifyProductFeedOptimizationChecklistImage from "../assets/images/blog/shopify-product-feed-optimization-checklist.jpg"
import googleMerchantCenterErrorsImage from "../assets/images/blog/google-merchant-center-errors.jpg"

// Keys must match the slug frontmatter field in src/content/blog/*.md
export const blogImagesBySlug = {
  "getting-started-with-ecommerce-feeds": gettingStartedImage,
  "optimize-meta-product-catalog": optimizeMetaCatalogImage,
  "google-shopping-product-title-optimization": googleProductTitleImage,
  "google-product-categories-explained": googleProductCategoriesImage,
  "shopify-product-feed-optimization-checklist": shopifyProductFeedOptimizationChecklistImage,  
  "google-merchant-center-errors-guide": googleMerchantCenterErrorsImage,
}

export const getPostImage = (post) => (post ? blogImagesBySlug[post.slug] || null : null)
